module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/logo.82b9c7a5.png";